import { render, staticRenderFns } from "./cookie-consent.vue?vue&type=template&id=5dc541de&scoped=true&"
import script from "./cookie-consent.vue?vue&type=script&lang=js&"
export * from "./cookie-consent.vue?vue&type=script&lang=js&"
import style0 from "./cookie-consent.vue?vue&type=style&index=0&id=5dc541de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc541de",
  null
  
)

export default component.exports